export function b64EncodeUnicode(str) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
    }),
  );
}

export function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );
}
export function kFormatter(num) {
  return Math.abs(num) > 999 ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k' : Math.sign(num) * Math.abs(num);
}

export const getGradient =
  (minVal, maxVal, minOpacity = 1, maxOpacity = 1, mode = 'green-red') =>
  (val) => {
    const range = maxVal - minVal;
    const percentFromMax = (val - minVal) / range;
    const targetOpacity = minOpacity + (maxOpacity - minOpacity) * percentFromMax;

    switch (mode) {
      case 'green-red': {
        const targetRed = 255 * percentFromMax;
        const targetGreen = 255 - targetRed;

        return [`rgb(${targetRed}, ${targetGreen}, 0)`, targetOpacity];
      }
      case 'blue-red': {
        const targetRed = 255 * percentFromMax;
        const targetBlue = 255 - targetRed;

        return [`rgb(${targetRed}, 0, ${targetBlue})`, targetOpacity];
      }
      default:
        return [];
    }
  };

export const rgbToHex = (r, g, b) => {
  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
